export default __webpack_public_path__ + "static/media/ownership_opened_block.12ed452c.svg";